import Link from '../../../../../../mat/js/components/Common/Layout/Link/link';
import { navigationStates } from '../../../../../../mat/js/enums/navigationStates';

export default function ResourceColumn({ value, record }) {
  return (
    <div>
      <Link label={value} id={record.id} type={navigationStates.LOCATION_TASKS} />
      <span>{` (${record.utl})`}</span>
    </div>
  );
}
